import { ZodFirstPartyTypeKind, type ZodDiscriminatedUnionDef, type ZodTypeDef } from 'zod';

import { isDefType } from './isDefType';

export function isDiscriminatedUnionDef(def: ZodTypeDef): def is ZodDiscriminatedUnionDef<string> {
    return isDefType(def, ZodFirstPartyTypeKind.ZodDiscriminatedUnion);
}
